export default __webpack_public_path__ + "static/media/Chris_En.6dd47a93.webp";